import React from "react";
import { Row, Col } from "react-bootstrap";

export default function AnalyticFilter({ productId, chartUrl }) {
  const isLastMonth = window.location.search.includes("date_filter");
  const chartLinkUrl = chartUrl || `/merchants/products/${productId}/chart`;

  return (
    <Row>
      <Col xs={12}>
        <div className="btn-group btn-group-justified">
          <a
            href={chartLinkUrl}
            className={`btn btn-secondary ${!isLastMonth ? "active" : ""}`}
          >
            Letzten 12 Wochen
          </a>
          <a
            href={`${chartLinkUrl}?date_filter=last_month`}
            className={`btn btn-secondary ${isLastMonth ? "active" : ""}`}
          >
            Letzten 4 Wochen
          </a>
        </div>
      </Col>
    </Row>
  );
}
